// 対面指導日程作成画面（/admin/online-lessons/user_groups/{id}/create）の振替関連入力
// - 「振替授業」チェックのON/OFFに応じた備考欄・自動紐付けチェックボックスの表示制御
//
// 対象のDOM:
//   [data-make-up-class-checkbox]  ... グループごとの「振替授業」チェックボックス（jquery.repeaterで複製される）
//   [data-make-up-remarks-section] ... 備考欄と「欠席情報を自動で紐付ける」チェックボックスを含むブロック

const SECTION_SELECTOR = '[data-make-up-remarks-section]'
const CHECKBOX_SELECTOR = '[data-make-up-class-checkbox]'

/**
 * 振替授業チェックの状態に応じて備考欄ブロックの表示を切り替える
 *
 * @param {HTMLElement} form
 * @param {HTMLElement} section
 */
const syncSectionVisibility = (form, section) => {
    const hasMakeUpClass = form.querySelector(`${CHECKBOX_SELECTOR}:checked`) !== null
    section.classList.toggle('hidden', !hasMakeUpClass)
}

const initOnlineLessonMakeUpRemarks = () => {
    const section = document.querySelector(SECTION_SELECTOR)
    if (section === null) {
        return
    }

    const form = section.closest('form')
    if (form === null) {
        return
    }

    const sync = () => syncSectionVisibility(form, section)

    // チェックボックスは jquery.repeater で動的に増減するためイベント委譲で監視する
    form.addEventListener('change', (event) => {
        if (event.target instanceof Element && event.target.matches(CHECKBOX_SELECTOR)) {
            sync()
        }
    })

    // グループの追加・削除（DOMの増減）にも追随させる
    const observer = new MutationObserver(sync)
    observer.observe(form, { childList: true, subtree: true })

    sync()
}

document.addEventListener('DOMContentLoaded', initOnlineLessonMakeUpRemarks)
